import * as PIXI from 'pixi.js';
import { ParentMixin } from '../core/parentMixin';
import { UpdateFlowMixin } from '../core/updateFlowMixin';
import { SerializableMixin } from '../core/serializableMixin';
import {
    AlphaAttribute,
    ColorAttribute,
    getAttributesToSerialize,
    NumberAttribute,
    StringOrNumberAttribute,
} from '../core/attributes';
import { Config } from '../video-data/config';

export class DynamicBoxBorderConfigurator extends UpdateFlowMixin(
    ParentMixin(SerializableMixin(PIXI.utils.EventEmitter)),
) {
    override _name = 'dynamicBoxBorderConfigurator';
    override _classType = 'DynamicBoxBorderConfigurator';
    readonly graphicType = Config.BOX_BORDER_GRAPHIC;

    @StringOrNumberAttribute({ choices: Config.ALL_INFERRED_HEIGHT })
    private accessor boxHeight = 'height';
    @StringOrNumberAttribute({ choices: Config.ALL_INFERRED_WIDTH })
    private accessor boxWidth = 'width';
    @NumberAttribute()
    accessor start0 = 0.25;
    @NumberAttribute()
    accessor end0 = 0.75;
    @NumberAttribute()
    accessor start1 = 0.75;
    @NumberAttribute()
    accessor end1 = 0.25;
    @NumberAttribute({ animatable: false })
    accessor horizontalPadding = 20;
    @NumberAttribute({ animatable: false })
    accessor verticalPadding = 20;
    @NumberAttribute({ min: 0, animatable: false })
    accessor borderThickness = 5;
    @ColorAttribute()
    accessor borderColor = 0xffffff;
    @AlphaAttribute()
    accessor borderAlpha = 0.5;
    @NumberAttribute({ min: 0, animatable: false })
    accessor topLeftRadius = 0;
    @NumberAttribute({ min: 0, animatable: false })
    accessor topRightRadius = 0;
    @NumberAttribute({ min: 0, animatable: false })
    accessor bottomRightRadius = 0;
    @NumberAttribute({ min: 0, animatable: false })
    accessor bottomLeftRadius = 0;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-useless-constructor
    constructor(settings: any) {
        super(settings);
    }

    override get readonlyProperties(): string[] {
        return [];
    }

    override get propertiesToSerialize() {
        return getAttributesToSerialize(this);
    }

    override get editableProperties() {
        return super.editableProperties.concat(['borderColor', 'borderAlpha']);
    }
}
